 import React from 'react'
 import Info from '../components/Aboutpage/info'
 import Hero from '../components/Hero'
 import aboutBcg from '../images/aboutBcg.jpeg'
 function AboutPage() {
     return (
         <>
             <Hero img={aboutBcg}>

             </Hero>
             <Info/> 
         </>
     )
 }
 
 export default AboutPage
 